import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import FirstScreen from "./pages/Auth/FirstScreen";
import WelcomeScreen from "./pages/Auth/WelcomeScreen";
import LogInScreen from "./pages/Auth/LogInScreen";
import RegisterScreen from "./pages/Auth/RegisterScreen";
import EmailConfirmation from "./pages/Auth/EmailConfirmation";
import ClubInfo1 from "./pages/Auth/ClubInfo1";
import FirstClub from "./pages/Auth/FirstClub";
import { useNavigationType } from "react-router-dom";
import ClubInfo2 from "./pages/Auth/ClubInfo2";
import ClubInfo3 from "./pages/Auth/ClubInfo3";
import AddNewCourt1 from "./pages/Auth/AddNewCourt1";
import SeeAllCourts from "./pages/Auth/SeeAllCourts";
import AddOrganization from "./pages/Auth/AddOrganization";
import AddOrganization2 from "./pages/Auth/AddOrganization2";
import Feed from "./layouts/Feed";

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dictionary from "./dictionary/dictionary.json";
import arabic from "./dictionary/arabic.json";
import { setDictonary, setLang } from "./lib/redux/slices/userSlice";
import FinalMapPage from "./pages/leagues/FinalMapPage";
import NotFound from "./pages/404/NotFound";

import { onMessage } from "firebase/messaging";
import { generateToken, messaging } from "./notification/firebase";
import Leaderboard from "./pages/leagues/Leaderboard";
import EventsLeaderboard from "./pages/events/EventsLeaderboard";
import TournamentFinalMapPage from "./pages/leagues/TournamentFinalMapPage";
import { Api, useTranslationsQuery } from "./lib/redux/services/Api";
import HelpCenter from "./pages/help center/HelpCenter";

import ForgetPassword from "./pages/Auth/ForgetPassword";
import ForgetPasswordRequest from "./pages/Auth/ForgetPasswordRequest";
import ShareModal from "./components/global/ShareModal";
import Modal from "./components/global/Modal";
import {
  closeShareModel,
  controllSliceType,
  resetHomeSidebarInfo,
  setSortingOption,
  storeWindowPathname,
} from "./lib/redux/slices/controlSlice";

import Sidebar from "./layouts/Sidebar";
import { useViewport } from "./hooks/useViewport";
import BottomNav from "./mobile components/BottomNav";
import { MOBILE_VIEW_ENDPOINT } from "./constants";
import LeaderBoardProvider from "./pages/events/LeaderBoardProvider";
import { useReadNotificationMutation } from "./lib/redux/services/sections/ChatAndNotification";
import TypeWarningModal from "./components/global/TypeWarningModal";
import ModalFactory from "./components/global/ModalFactory";
import Policy from "./pages/policy/Policy";
function App() {
  const dispatch = useDispatch();
  const lang = useSelector((state: any) => state?.user?.lang);

  const isShareModelOpen = useSelector(
    (state: any) => state?.control?.ShareModelOpen
  );
  const generalModelinfo = useSelector(
    (state: any) => state?.control?.generalModelinfo
  );

  const shareModelInfo = useSelector(
    (state: any) => state?.control?.shareModelInfo
  );
  const unReadedMsgs = useSelector(
    (state: any) => state?.control?.newReadedMsgs
  );
  const previousWindowPathname = useSelector(
    (state: any) => state?.control?.windowPathname
  );
  const location = useLocation();
  const { isMobile, sizeInfo } = useViewport();
  const [ReadNotifications] = useReadNotificationMutation();
  //const lang = localStorage.getItem("lang") || reduxLang;
  const { data, isSuccess } = useTranslationsQuery(lang);
  useEffect(() => {
    const isEnabled = localStorage.getItem("isEnabledRules");
    if (!isEnabled) {
      localStorage.setItem("isEnabledRules", "false");
    }
    if (data && isSuccess) {
      console.log(data);

      dispatch(setDictonary(data));
    }
  }, [lang, data, isSuccess]);
  useEffect(() => {
    dispatch(setLang(localStorage.getItem("lang") || "en"));

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("SW registered:", registration);
        })
        .catch((error) => {
          console.log("SW registration failed:", error);
        });
    }

    if (!localStorage.getItem("fcmToken")) {
      generateToken();
    }

    // ✅ 1. للرسائل في الواجهة (Foreground)
    onMessage(messaging, (payload) => {
      dispatch(Api.util.invalidateTags(["notifications"]));
      console.log("Foreground message received: ", payload);
    });

    // ✅ 2. للرسائل من الخلفية (Background) عبر Service Worker
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "UPDATE_NOTIFICATIONS") {
          console.log(
            "Background message received via SW: ",
            event.data.payload
          );
          dispatch(Api.util.invalidateTags(["notifications"]));
        }
      });
    }

    // ✅ 3. تحديث الإشعارات عند فتح التطبيق
    dispatch(Api.util.invalidateTags(["notifications"]));
  }, [dispatch]);
  useEffect(() => {
    const fetchUnreadMessages = async () => {
      try {
        console.log("unReadedMsgs", unReadedMsgs);

        // Call your async function here
        await ReadNotifications({
          notification_ids: unReadedMsgs,
          all_notifications: false,
        })
          .unwrap()
          .then(() => {
            dispatch(Api.util.invalidateTags(["notifications"]));
          });
      } catch (error) {
        console.error("Error in async function:", error);
      }
    };
    if (unReadedMsgs.length > 0) {
      fetchUnreadMessages();
    }
    if (previousWindowPathname !== window.location.pathname) {
      //@ts-ignore
      dispatch(setSortingOption({ column: "", order: "" }));
      //@ts-ignore
      dispatch(storeWindowPathname(window.location.pathname));
    }
    dispatch(resetHomeSidebarInfo())
  }, [location.pathname, location.search]);
  return (
    <div
      className="text-primary dark:text-white  "
      dir={lang == "ar" ? "rtl" : "ltr"}
    >
      <Routes>
        <Route path="not-found" element={<NotFound />} />
        <Route path={"/"} element={<FirstScreen />} />
        <Route path="/auth">
          <Route path="welcome" element={<WelcomeScreen />} />
          <Route path="login" element={<LogInScreen />} />
          <Route
            path="forget-password-request"
            element={<ForgetPasswordRequest />}
          />
          <Route path="forget-password" element={<ForgetPassword />} />
          <Route path="register/:id?" element={<RegisterScreen />} />
          <Route path="email-confirmation" element={<EmailConfirmation />} />
          <Route path="first-club" element={<FirstClub />} />
          <Route path="club-info-1/:club_id" element={<ClubInfo1 />} />
          <Route path="club-info-2/:club_id" element={<ClubInfo2 />} />
          <Route path="club-info-3/:club_id" element={<ClubInfo3 />} />
          <Route
            path="add-new-court-1/:club_id/:court_id?"
            element={<AddNewCourt1 />}
          />
          <Route path="see-all-courts/:club_id" element={<SeeAllCourts />} />
          <Route path="add-organization" element={<AddOrganization />} />
          <Route path="add-organization2" element={<AddOrganization2 />} />
        </Route>
        <Route
          path="/competitive/leagues/final/:id"
          element={<FinalMapPage type="leagues" />}
        />
        <Route
          path="/competitive/leagues/final/share/:id"
          element={<FinalMapPage type="leagues" isShareMode={true} />}
        />
        <Route
          path="/competitive/tournaments/final/knockouts/:id"
          element={<TournamentFinalMapPage />}
        />
        <Route
          path="/competitive/tournaments/final/rounds/:id"
          element={<FinalMapPage type="tournaments" />}
        />
        <Route
          path="/competitive/tournaments/final/share/knockouts/:id"
          element={<TournamentFinalMapPage isShareMode={true} />}
        />
        <Route
          path="/competitive/tournaments/final/share/rounds/:id"
          element={<FinalMapPage type="tournaments" isShareMode={true} />}
        />
        <Route
          path="/competitive/leaderboard/:id"
          element={<LeaderBoardProvider leaderBoardType="league-tournament" />}
        />
        <Route
          path="/events/leaderboard/:id"
          element={<LeaderBoardProvider leaderBoardType="event" />}
        />
        <Route path="/policy/:id" element={<Policy />} />
        <Route
          path="*"
          element={
            <div className="flex w-full h-dvh  ">
              {/* <Sidebar /> */}
              <Sidebar />
              <Feed />
              {sizeInfo.currentWidth < MOBILE_VIEW_ENDPOINT && <BottomNav />}
              {isShareModelOpen && (
                <Modal
                  isOpen={isShareModelOpen}
                  onClose={() => {
                    dispatch(closeShareModel());
                  }}
                >
                  <ShareModal inviteLink={shareModelInfo} />
                </Modal>
              )}
              {<ModalFactory />}
              {generalModelinfo.isOpen && (
                <Modal
                  isOpen={generalModelinfo.isOpen}
                  modalMaxWidth="max-w-[450px]"
                  onClose={() => {
                    dispatch(closeShareModel());
                  }}
                >
                  <TypeWarningModal
                    information={generalModelinfo.info}
                    type={generalModelinfo.type}
                  />
                </Modal>
              )}
            </div>
          }
        />
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
